module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label label-success",
    attrs: {
      "title": "Copy to clipboard"
    },
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_vm._v("\n  " + _vm._s(_vm.tag.name) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/template-compiler?{"id":"data-v-b33daece"}!/home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/selector.js?type=template&index=0!./modules/repositories/components/tag.vue
// module id = 365
// module chunks = 0